import {
  AgeRestrictedError,
  ChannelNotFoundError,
  ConnectAccessDeniedError,
  EulaRequiredError,
  SubscriptionInactiveError,
} from '@/shared/domain'
import { HttpError } from '@/shared/infra/http'

const SUBSCRIPTION_INACTIVE_MESSAGE = 'organization subscription is not active'

function readBodyMessage(body: unknown): string {
  if (body !== null && typeof body === 'object' && 'error' in body) {
    const value = (body as { error: unknown }).error
    if (typeof value === 'string') return value
  }
  return ''
}

export function mapConnectError(error: unknown): Error {
  if (!(error instanceof Error)) {
    return new Error(String(error))
  }
  if (error instanceof HttpError) {
    const bodyMessage = readBodyMessage(error.body).toLowerCase()
    if (error.status === 403 && bodyMessage.includes(SUBSCRIPTION_INACTIVE_MESSAGE)) {
      return new SubscriptionInactiveError(error.message)
    }
  }
  const message = error.message.toLowerCase()
  if (message.includes('http 451')) {
    return new AgeRestrictedError()
  }
  if (message.includes('http 428')) {
    return new EulaRequiredError()
  }
  if (message.includes('http 403')) {
    return new ConnectAccessDeniedError()
  }
  if (message.includes('http 404')) {
    return new ChannelNotFoundError()
  }
  return error
}
